import React, { Component } from 'react';
import { Select } from 'antd';

const fontFamilies = [{
    name: "默认",
    value: "auto"
},{
    name: "宋体",
    value: "SimSun"
}, {
    name: "黑体",
    value: "SimHei"
}, {
    name: "微软雅黑",
    value: "Microsoft Yahei"
}, {
    name: "楷体",
    value: "KaiTi"
}, {
    name: "新宋体",
    value: "NSimSun"
}, {
    name: "仿宋",
    value: "FangSong"
}, {
    name: "幼圆",
    value: "YouYuan"
}, {
    name: "隶书",
    value: "LiSu"
}]


export default class FontFamilySelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null
        }
    }
    componentDidMount() {
        if (this.props.defaultValue) {
            this.setState({
                value: this.props.defaultValue
            });
        } else if (this.props.value) {
            this.setState({
                value: this.props.value
            });
        }
    }
    componentWillReceiveProps(props) {
        if (props.value !== this.props.value) {
            this.setState({
                value: props.value
            });
        }
    }
    onChange(value) {
        this.setState({
            value: value
        });
        this.props.onChange && this.props.onChange(value);
    }
    render() {
        let families = this.props.items || fontFamilies;
        return <Select value={this.state.value} onChange={value => this.onChange(value)} style={{
            ...this.props.style
        }}>
            {families.map((item, index) => {
                return <Select.Option key={index} value={item.value}>{item.name}</Select.Option>
            })}
        </Select>
    }
}